import { Link } from "react-router-dom"
import "./Navbar3.css"

export default function Navbar3() {
  return (
    <div className="navbar3">
      <nav>
        <Link to="/" className="brand3">
          <h2>more news soon...</h2>
          <>
            <h1>✌️</h1>
          </>
        </Link>
      </nav>
    </div>
  )
}
